import useQuasar from './quasar'
import useWStorage from './vue-wstorage'
import useECharts from './vue-echarts'

export default function usePlugins(app) {
    useQuasar(app)
    useWStorage(app)
    useECharts(app)
}
